export default "__VITE_ASSET__CkK8tVQw__"